type IntentAndEntityConstants = {
  STORE_ENTITY_STATS: string;
  STORE_INTENT_STATS: string;
};
export const Constants: IntentAndEntityConstants = {
  STORE_INTENT_STATS: 'STORE_INTENT_STATS',
  STORE_ENTITY_STATS: 'STORE_ENTITY_STATS',
};
